import { global_hooks } from 'src/globals';
import Dropdown from 'components/ui/dropdown/Dropdown';
import Buttons from 'components/ui/buttons/Buttons';

// import './filters_ajax';

global_hooks.on('listing/init', init);

let update_debounce;

function init(listing) {
	listing.filters = {
		fields: [],
	};

	listing.hooks.add_filter('search_items', (items) => {
		return get_result(items, listing.filters);
	});

	init_fields(listing);
}

function init_fields(listing) {
	if (!listing.args.filters?.length) return;

	listing.args.filters.forEach((field_args) => {
		const filter = init_filter(field_args, listing);

		switch (field_args.type) {
			case 'dropdown':
				init_field_dropdown(field_args, filter, listing);
				break;

			case 'buttons':
				init_field_buttons(field_args, filter, listing);
				break;
		}
	});
}

function init_filter(field_args, listing) {
	const filter = {
		key: field_args.key,
		data_target: field_args.data_target ?? 'key',
		compare: field_args.compare ?? 'in',
		relation: field_args.relation ?? 'or',
		value: '',
	};

	listing.filters.fields.push(filter);

	return filter;
}

function init_field_dropdown(field_args, filter, listing) {
	const dropdown = new Dropdown(field_args.el, {
		raw: field_args.raw ?? true,
	});

	const handle_select = (option) => {
		filter.value = option.value;
		update_result(listing);
	};

	dropdown.hooks.on('select', handle_select);
}

function init_field_buttons(field_args, filter, listing) {
	const buttons = new Buttons(field_args.el, field_args);

	const handle_change = () => {
		filter.value = buttons.get_value();
		update_result(listing);
	};

	buttons.hooks.on('update', handle_change);
}

function update_result(listing) {
	clearTimeout(update_debounce);
	update_debounce = setTimeout(() => {
		_update_result(listing);
	}, 200);
}

async function _update_result(listing) {
	// if (listing.ajax_filters) {
	// 	// use ajax filter query instead
	// 	return listing.hooks.do('filter/result/override', listing);
	// }

	const loading = listing.loading();

	await listing.wait_load_all();

	const items = listing.hooks.apply_filter('filter_items', listing.items);

	const result = get_result(items, listing.filters);

	loading.end(() => {
		listing.hooks.do('result/render', result);
	});
}

function get_result(items, filters) {
	if (!have_filters(filters)) {
		return items;
	}

	const result = [];

	items.forEach((item) => {
		if (item_pass(item, filters)) {
			result.push(item);
		}
	});

	return result;
}

function item_pass(item, filters) {
	for (const field of filters.fields) {
		if (!field.value || !field.value.length) continue;
		if (!item_found(item, field)) {
			return false;
		}
	}
	return true;
}

function item_found(item, args) {
	if (!item.data[args.key]) return false;

	if (args.compare === '=') {
		return item.data[args.key] == args.value;
	}

	if (args.compare === 'in') {
		if (args.data_target === 'key') {
			return logic_in_key(item, args);
		}

		return logic_in_array(item, args);
	}

	return item.data[args.key] == args.value;
}

function logic_in_key(item, args) {
	if (Array.isArray(args.value)) {
		if (args.relation === 'or') {
			// or
			for (const value_item of args.value) {
				if (item.data[args.key][value_item]) {
					return true;
				}
			}

			return false;
		} else {
			// and
			for (const value_item of args.value) {
				if (!item.data[args.key][value_item]) {
					return false;
				}
			}

			return true;
		}
	}

	return item.data[args.key][args.value];
}

function logic_in_array(item, args) {
	if (Array.isArray(args.value)) {
		if (args.relation === 'or') {
			// or
			for (const value_item of args.value) {
				if (item.data[args.key].includes(value_item)) {
					return true;
				}
			}

			return false;
		} else {
			// and
			for (const value_item of args.value) {
				if (!item.data[args.key].includes(value_item)) {
					return false;
				}
			}

			return true;
		}
	}

	return item.data[args.key].includes(args.value);
}

function have_filters(filters) {
	for (const field of filters.fields) {
		if (field.value || field.value.length) return true;
	}
	return false;
}
